import { TemplateDefaults } from "../../../library-templates/TemplateDefaults";
import { AttributeValue } from "../../dom-tools/AttributeValue";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementSelector } from "../../dom-tools/ElementSelector";
import { LCG } from "../../random/LCG";
import { SeedGenerator } from "../../random/SeedGenerator";
import { HueGradientBackground } from "./HueGradientBackground";
import { SetBackgroundAttribute } from "./SetBackgroundAttribute";

export class SetBackground
{  
  
  static applyOnDocument()
  {
    SetBackgroundAttribute.value.forEachInDoc( e => SetBackground.applyOnElement( e ) );
  }

  static applyOnElement( parentElement:Element )
  {
    let elements = TemplateDefaults.getAllSelected( parentElement );    
    
    elements.forEach(
       ( childElement )=>
       {
         let seed = this.getSeed( childElement, parentElement );
         SetBackground.setBackground( childElement, seed, parentElement );
       }
    );    
    
  }

  static getSeed( e:Element, p:Element ):number
  {    
    let seedTargetElement = ElementSelector.queryValue( TemplateDefaults.seed, p, e );
    return SeedGenerator.fromText( TemplateDefaults.getText( seedTargetElement, p ) ); 
  }

  static _random = new LCG();

  static setBackground( e:Element, seed:number, p:Element )
  {
    let backgroundElement = ElementSelector.fromAttribute( p, TemplateDefaults.targetSelector ).query( e );

    SetBackground._random.setSeed( seed );

    if ( HueGradientBackground.type.in( p ) )
    {
      HueGradientBackground.setBackground( e, backgroundElement, SetBackground._random, p );
    }
    
  }

} 